import React, { Component}  from 'react';
import gql from "graphql-tag";
import { Query } from "react-apollo";
import Comments from "./Comments";

const GET_CHANNELS = gql`{getChannels { id name }}`;

const Channels = ({ modalVisibility, onChannelSelected }) => (
    <Query query={GET_CHANNELS} skip={!modalVisibility}>
        {({loading, error, data}) => {
            if (loading) return " Loading...";
            if (error) return "Error! ${error.message}";

            return (
                <select name="channel" onChange={onChannelSelected} className="form-control" required>
                    <option key="" value=""></option>
                    {data.getChannels.map(channel => (
                        <option key={channel.id} value={JSON.stringify(channel)}>
                            #{channel.name}
                        </option>
                    ))}
                </select>
            );
        }}
    </Query>
);

export default Channels


// WEBPACK FOOTER //
// ./src/components/Channels.jsx